import { NgModule } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { SoilTypeEffects } from './store/soil-type.effects';
import { soilTypeReducer } from './store/soil-type.reducer';

@NgModule({
  providers: [provideState('soil-type', soilTypeReducer), provideEffects([SoilTypeEffects])],
})
export class SoilTypeModule {}
